import { ORIENTATION_CHANGED, VIEW_CHANGE } from './deviceActions'
import { distinctUntilChanged } from 'rxjs/operators'
import { Observable } from 'rxjs/Rx'
import 'rxjs/add/operator/takeWhile'
import { showLandscapePrompt } from 'aria-viewer/tour/tourActions'
import { TourActions } from 'aria-viewer/tour/constants'
import ModalContentTypes from 'aria-viewer/modal/constants/ModalContentTypes'
import getBool from 'aria-viewer/utils/getBool'
import { getEnv } from 'aria-viewer/utils/environment'

const isRegistrationModalOpen = state =>
    state
        .getIn(['modal', 'modalStack'])
        .some(modal =>
            [ModalContentTypes.WELCOME_REGISTRATION, ModalContentTypes.REGISTRATION].includes(modal.content.type)
        )

export default (action$, store) => {
    const isLandscapeMessageEnabled = getBool(getEnv('REACT_APP_SHOW_LANDSCAPE_MESSAGE'))

    const deviceOrientation$ = action$
        .takeWhile(_ => isLandscapeMessageEnabled && !store.getState().getIn(['device', 'isDeviceIOS']))
        .ofType(ORIENTATION_CHANGED)
        .filter(_ => !isRegistrationModalOpen(store.getState()))
        .distinctUntilChanged()
        .switchMap(action =>
            Observable.of(action)
                .delay(1000)
                .mapTo(showLandscapePrompt(true))
        )
        .takeUntil(action$.ofType(TourActions.SET_LANDSCAPE_PROMPT))

    const viewChange$ = action$
        .takeWhile(_ => isLandscapeMessageEnabled && store.getState().getIn(['device', 'isDeviceIOS']))
        .ofType(VIEW_CHANGE)
        .filter(action => action.isMinimalView && !isRegistrationModalOpen(store.getState()))
        .switchMap(action =>
            Observable.of(action)
                .delay(1000)
                .mapTo(showLandscapePrompt(true))
        )
        .takeUntil(action$.ofType(TourActions.SET_LANDSCAPE_PROMPT))

    const landscapePrompt$ = action$
        .takeWhile(_ => isLandscapeMessageEnabled)
        .ofType(TourActions.SET_LANDSCAPE_PROMPT)
        .switchMap(action =>
            Observable.of(action)
                .delay(3000)
                .mapTo(showLandscapePrompt(false))
        )

    return Observable.merge(deviceOrientation$, viewChange$, landscapePrompt$)
}
